module.exports = __webpack_public_path__ + "static/img/teknomalaysia.b62062b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teknomalaysia.png
// module id = LUP8
// module chunks = 83